import React from "react";

interface IConfirmationForm {
  form: any;
  handleSubmit: any;
}

const ConfirmationForm: React.FC<IConfirmationForm> = ({ form, handleSubmit }) => {
  console.log("sndjedfksfewfhjdskfj", form)
  const formData = form ?? {
    product: "SELECTED PRODUCT",
    art: "SELECTED ART",
    width: "SELECTED BREITE",
    depth: "SELECTED TIEFE",
    color: "SELECTED FARBE",
    led: "SELECTED LED",
    service: "SELECTED MONTAGE",
    location: "SELECTED STANDORT",
  };





  return (
    <div className="flex flex-col items-center ">
      <div className="w-full bg-gray-100 grid grid-cols-2 sm:grid-cols-2 gap-3 p-2 pb-8 rounded-3xl shadow-md">
        <div className="flex flex-col">
          <label className="p-1 pl-2 text-xs sm:text-sm font-medium">Produkt</label>
          <div className="p-2 bg-white rounded-full border border-gray-300 text-center truncate text-xs sm:text-sm">
            {formData.product}
          </div>
        </div>

        <div className="flex flex-col">
          <label className="p-1 pl-2 text-xs sm:text-sm font-medium">Art</label>
          <div className="p-2 bg-white rounded-full border border-gray-300 text-center truncate text-xs sm:text-sm">
            {formData.installationType}
          </div>
        </div>

        <div className="flex flex-col">
          <label className="p-1 pl-2 text-xs sm:text-sm font-medium">Breite</label>
          <div className="p-2 bg-white rounded-full border border-gray-300 text-center truncate text-xs sm:text-sm">
            {formData?.dimensions.width} m
          </div>
        </div>

        <div className="flex flex-col">
          <label className="p-1 pl-2 text-xs sm:text-sm font-medium">Tiefe</label>
          <div className="p-2 bg-white rounded-full border border-gray-300 text-center truncate text-xs sm:text-sm">
            {formData.dimensions?.depth} m
          </div>
        </div>

        <div className="flex flex-col col-span-2">
          <label className="p-1 pl-2 text-xs sm:text-sm font-medium">Endeckung</label>
          <div className="p-2 bg-white rounded-full border border-gray-300 text-center truncate text-xs sm:text-sm">
            {formData?.productCovering}
          </div>
        </div>

        <div className="flex flex-col">
          <label className="p-1 pl-2 text-xs sm:text-sm font-medium">Farbe</label>
          <div className="p-2 bg-white rounded-full border border-gray-300 text-center truncate text-xs sm:text-sm">
            {formData.color}
          </div>
        </div>

        <div className="flex flex-col">
          <label className="p-1  pl-2 text-xs sm:text-sm font-medium">LED</label>
          <div className="p-2 bg-white rounded-full border border-gray-300 text-center truncate text-xs sm:text-sm">
            {formData.ledOption}
          </div>
        </div>

        <div className="flex flex-col">
          <label className="p-1  pl-2 text-xs sm:text-sm font-medium">Montageservice</label>
          <div className="p-2 bg-white rounded-full border border-gray-300 text-center truncate text-xs sm:text-sm">
            {formData?.service}
          </div>
        </div>

        <div className="flex flex-col">
          <label className="p-1 pl-2 text-xs sm:text-sm font-medium">Standort</label>
          <div className="p-2 bg-white rounded-full border border-gray-300 text-center truncate text-xs sm:text-sm">
            {formData?.selectedBranch?.name}
          </div>
        </div>


      </div>

      <button
        onClick={handleSubmit}
        className="w-full bg-white text-black text-center font-bold py-3 rounded-full border border-gray-300 mt-6 flex items-center justify-center hover:bg-gray-200 text-sm sm:text-base"
      >
        Jetzt Angebot anfordern <span className="text-red-600 ml-2">&gt;</span>
      </button>
    </div>
  );
};

export default ConfirmationForm;
